<template>
  <div></div>
</template>

<script>
  export default {
    name: "user-audit",
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="scss" scoped>

</style>